import React from 'react'
import './contact-info-tab.css'
import { MdContentCopy } from 'react-icons/md'
import StudentBadge from '../StudentBadge/StudentBadge'
import axios from 'axios'
import { baseUrl } from '../../../assets/Animations'
import { getRequestHeaders } from '../../../api'
import FindFamilyProfileSearchBox from './FindFamilyProfileSearchBox/FindFamilyProfileSearchBox'

let familyInfoSections = [
    {label: 'Name', displayType: 'array', type: ['primaryParentName','familyName']},
    {label: 'Email', displayType: 'array', type: ['primaryEmail']},
    {label: 'Phone Number', displayType: 'array', type: ['primaryCellphone']},
    {label: 'Address', displayType: 'object', type: ['address']},
    // {label: 'Availability', displayType: 'object', type: ['initialAvailability']},
    // {label: 'Notes', displayType: 'array', type: ['initialAvailabilityNotes']},
    {label: 'Message', displayType: 'object', type: ['todoDescription']},
]

const ContactInfoTab = ({modalInfo, setModalInfo, setCopyConfirmationPopup, familyInfo, loadingFamilyInfo, hookUpFamily, scheduledEvents, getFamilyInfo}) => {

    const copyNewStudentFormUrlToClipboard = () => {
        let schoolName = ''
        switch(modalInfo.whichSchool) {
            default:
                schoolName = 'app'
                break;
            case 'mma':
                schoolName = 'mountainside'
                break;
            case 'lsma':
                schoolName = 'lakeside'
                break;
            case 'tma':
                schoolName = 'treeside'
                break;
            case 'mor':
                schoolName = 'morningside'
                break;
            case 'psma':
                schoolName = 'parkside'
        }
        navigator.clipboard.writeText(`https://${schoolName}.atharo.app/new-student/${modalInfo.familyId}`)
        .then(() => {
            setCopyConfirmationPopup(true)
        })
        .catch(err => console.log(err))
    }

    const copyEmailToClipboard = async () => {
        await navigator.clipboard.writeText(familyInfo.primaryEmail)

        alert('Email copied to clipboard!')
    }

    if(hookUpFamily) {
        return (
            loadingFamilyInfo 
            ? 
            <div className='family-info-gutter__loading-blink'>Loading family info...</div>
            :
            <div>
                <FindFamilyProfileSearchBox modalInfo={modalInfo} setModalInfo={setModalInfo} getFamilyInfo={getFamilyInfo} />
            </div>
        )
    } else {
        if(!familyInfo) {
            return (
                <div>
                    <div className='family-info-gutter__new-student-form-btn'>
                        <div className='family-info-gutter__new-student-form-btn__text' onClick={() => copyNewStudentFormUrlToClipboard()}>New Student Form</div>
                        <MdContentCopy />
                    </div>
                    <div className='family-info-gutter__family-with-id-missing'>This family has an ID but is not in the database for some reason. Feel free to send the family the "New Student Form" link again.</div>
                </div>
            )
        } else {
            return (
                <div>
                    <div className='family-info-gutter__new-student-form-btn' onClick={() => copyNewStudentFormUrlToClipboard()}>
                        <div className='family-info-gutter__new-student-form-btn__text'>New Student Form</div>
                        <MdContentCopy />
                    </div>
                    <div className='family-info-gutter__scroll-wrapper'>
                        <div className='family-info-gutter__student-badge__wrapper'>
                            {modalInfo.studentList.map((student) => 
                                <StudentBadge 
                                    key={student.studentId}
                                    familyInfo={familyInfo} 
                                    student={student} 
                                    scheduledEvents={scheduledEvents}
                                />
                            )}
                        </div>
                        <div className='family-info-gutter__family-info-area'>
                            {familyInfoSections.map((section, index) => (
                                <div key={index} className='family-info-gutter__family-info-chunk' style={section.label === 'Email' ? {cursor: 'pointer'} : {cursor: 'default'}} onClick={() => section.label === 'Email' && copyEmailToClipboard()}>
                                    <div className='family-info-gutter__family-info-chunk__label'>{section.label}</div>
                                    <div className='family-info-gutter__family-info-chunk__details__wrapper'>
                                        {section.displayType === 'array' ?
                                         section.type.map((type,index) =>
                                            <div key={index} className='family-info-gutter__family-info-chunk__details'>
                                                {familyInfo && familyInfo[type]}                                    
                                            </div>    
                                        )
                                        :
                                        <div className='family-info-gutter__family-info-chunk__address'>
                                            {section.label === 'Address' && 
                                                <div>
                                                    {Object.keys(familyInfo[section.type]).map((key, index) => (
                                                        <div key={index}>{familyInfo[section.type][key]}</div>
                                                    ))}
                                                </div>
                                            }
    
                                            {section.label === 'Availability' &&
                                                <div>
                                                    {familyInfo[section.type] && Object.keys(familyInfo[section.type]).map((key, index) => (
                                                        <div key={index}>
                                                            {Object.keys(familyInfo[section.type][key]).map((day, index) => (
                                                                <div key={index}>{key}: {day}</div>
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            }
                                            {section.label === 'Message' &&
                                            <div className='contact-tab__message__wrapper'>
                                                <div>{modalInfo[section.type] === '' ? familyInfo.initialAvailabilityNotes : modalInfo[section.type]}</div>
                                            </div>
                                            }
                                        </div>
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )
    }

    }
}
export default ContactInfoTab